<template>
  <el-dialog
    title="拣货"
    :visible.sync="dialogFormVisible"
    width="60vw"
    height="100vh"
    top="2vh"
    :fullscreen="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
  >
    <el-form ref="queryForm" :inline="true" :model="queryForm" :rules="formRules" @submit.native.prevent>
      <!-- 库位编号 -->
      <el-form-item label="库位编号" prop="positionNum">
        <el-input ref="positionNum" v-model.trim="queryForm.positionNum" clearable placeholder="请扫描" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <!-- 商品编号 -->
      <el-form-item label="商品编号" prop="itemNo">
        <el-input ref="itemNo" v-model.trim="queryForm.itemNo" clearable placeholder="请扫描" @keyup.enter.native="handleQueryItemNo" />
      </el-form-item>
    </el-form>
    <el-table v-loading="listLoading" :data="tableData" border style="width: 100%" :cell-style="setRowStyle">
      <!-- 拣货状态 -->
      <el-table-column align="center" :label="$t('table_column_pickingStatus')">
        <template slot-scope="{ row }">
          <div v-if="row.status == 1">待拣货</div>
          <div v-if="row.status == 2">拣货完成</div>
        </template>
      </el-table-column>
      <!-- 任务编号-->
      <el-table-column align="center" prop="carContainerCode" label="任务编号" />
      <!-- 所在库位 -->
      <el-table-column align="center" prop="positionNum" label="所在库位" />
      <!-- 商品编号 -->
      <el-table-column align="center" prop="itemNo" label="商品编号" />
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">返回</el-button>
    </div>
    <!-- 错误提示音 -->
    <audio ref="audioPlayer" src="@/assets/audio.mp3" controls style="display: none" />
    <!-- 成功提示音 -->
    <audio ref="successAudioPlayer" src="@/assets/success.mp3" controls style="display: none" />
  </el-dialog>
</template>
<script>
import { task_detail, task_picking } from '@/api/xgcApi'
export default {
  name: 'BoxBinding',
  data() {
    return {
      dialogFormVisible: false, // 弹窗显示,隐藏
      listLoading: false, // 请求数据加载
      innerVisible: false,
      tableData: [],
      innerTableData: [],
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      queryForm: {
        page: 1,
        limit: 10,
        positionNum: '',
        itemNo: '',
        id: '',
        actualQty: '',
        task_code:''
      },
      formRules: {
        positionNum: [
          {
            required: true,
            message: this.$t('Please_scan'), // 请扫描
            trigger: 'blur'
          }
        ],
        itemNo: [
          {
            required: true,
            message: this.$t('Please_scan'), // 请扫描
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    // 根据条件设置样式，例如改变背景色和字体颜色等。
    setRowStyle({ row, rowIndex }) {
      if (row.status == 0) {
        return {
          backgroundColor: '#ffff7f'
        }
      } else if (row.status == 2) {
        return {
          backgroundColor: '#55ff7f'
        }
      } else {
        return {
          backgroundColor: ''
        }
      }
    },
    // 页面初始化方法
    showEdit(row) {
        console.log(row,'989898')

        console.log(row.id,'iddddd')
    //   this.queryForm.id = row.id
    //   this.queryForm.task_code = row.task_code
      this.dialogFormVisible = true
    //   this.getTableDataList(row) // 获取弹窗列表数据
    //   this.$nextTick(() => {
        // const input = this.$refs.positionNum
        // input.focus()
    //   })
    },
    // 获取弹窗列表数据
    getTableDataList(row) {
      this.listLoading = true
      console.log(row,'852369')
      return
      task_detail(row).then((res) => {
        this.tableData = res.data
        if(res.data.length > 0){
        this.queryForm.carContainerCode = res.data[0].carContainerCode
        }
      })
      setTimeout(() => {
        this.listLoading = false
      }, 300)
    },
    // 播放系统错误提示音
    playAudio() {
      this.$refs.audioPlayer.play()
    },
    // 播放系统成功提示音
    playSuccessAudio() {
      this.$refs.successAudioPlayer.play()
    },
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.getTableDataList()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.getTableDataList()
    },
    // 处理编辑逻辑，例如更新数据源等
    pickingSubmit(index, row) {
      const date = {
        id: this.queryForm.id,
        ...row
      }
      task_picking(date).then((res) => {
        // this.tableData = res.data.b2cPickingTaskItemVos || []
        this.$message({
          message: res.msg,
          type: 'success'
        })
        this.getTableDataList(this.queryForm.id)
      })
    },
    close() {
      this.dialogFormVisible = false
      this.$emit('fetch-data')
    },
    // 推荐库位提示
    open(e) {
      this.$alert(e, this.$t('hint'), {
        confirmButtonText: this.$t('public.determine'),
        callback: (action) => {}
      })
    },
    // 扫描成功
    handleQueryItemNo() {
      task_picking(this.queryForm)
        .then((res) => {
          this.getTableDataList(this.queryForm.id)
          if (res.data.flag == 1) {
            this.queryForm.positionNum = ''
            this.queryForm.containerCode = ''
            this.queryForm.boxCode = ''
            this.queryForm.itemNo = ''
            this.$nextTick(() => {
              const input = this.$refs.positionNum
              input.focus()
            })
            // this.open(res.data.msg)
          } else {
            this.queryForm.itemNo = ''
            this.$nextTick(() => {
              const input = this.$refs.itemNo
              input.focus()
            })
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.playSuccessAudio()
          }
        })
        .catch((res) => {
          this.playAudio()
          this.$nextTick(() => {
            const input = this.$refs.positionNum
            input.focus()
          })
          this.queryForm.positionNum = ''
          this.queryForm.containerCode = ''
          this.queryForm.boxCode = ''
          this.queryForm.itemNo = ''
        })
    },
    // 扫完库位编号跳转到托盘编号上
    handleQuery() {
      const input = this.$refs.containerCode
      input.focus()
    },
    // 扫完托盘编号跳转到箱码上
    handleQueryCode() {
      const input = this.$refs.boxCode
      input.focus()
    },
    // 扫完箱码跳转到商品编号上
    handleQueryBoxCode() {
      const input = this.$refs.itemNo
      input.focus()
    }
  }
}
</script>
<style>
.item_box {
  border: 1px solid #999;
  border-radius: 10px;
  padding: 16px;
  box-sizing: border-box;
  margin-bottom: 16px;
}

.warning-row {
  background: oldlace;
  /* 或者其他颜色 */
}

/*  .pickTaskNum .el-input__inner{

  background: #13ce66 !important;

  } */
</style>
